export const apiUrl = {
  getMainSignUpPricingPageData: "api/Plan/GetMainSignUpPricingPageData",
  verifyPromoCode: "api/PromoCode/VerifyPromoCode",
  saveAddOnitemsDetailForSignUpFromPricingPlan:
    "api/SignUp/SaveAddOnitemsDetailForSignUpFromPricingPlan",
}
